<template>
  <div class="smsVerificationWrapper text-center">
    <template>
      <ValidationObserver ref="numberForm">
        <div class="inputWrapper">
          <!-- <cool-select
            v-model="selectedCountry"
            :items="items"
            item-value="code"
            item-text="name"
            @select="onCountrySelected"
          >
            <template slot="item" slot-scope="{ item }">
              <div class="country-item">
                <img class="country-flag" :src="getFlag(item.code)" />
                <b class="country-code">{{ item.name }}</b>
              </div>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <ValidationProvider
                tag="div"
                name="country_code"
                :rules="'required|phonePrefix'"
                v-slot="{ errors }"
              >
                <div
                  :style="inputStyles"
                  class="country-selected-item"
                  :class="{ 'is-invalid': errors.length }"
                >
                  <img
                    class="country-flag"
                    v-if="item.phoneCode"
                    :src="getFlag(item.code)"
                  />
                  <div class="custom-input-wrap" v-if="item.code === 'other'">
                    <span>+</span>
                    <input
                      ref="customInput"
                      @keypress="onlyNumber"
                      v-model="countryCode"
                      type="text"
                      class="custom-input"
                      maxlength="4"
                    />
                    <img
                      v-if="errors.length"
                      class="custom-input-warn"
                      src="../../../assets/icons/risk-icon.svg"
                      height="18px"
                      width="18px"
                      alt=""
                    />
                  </div>
                  <input v-else v-model="countryCode" type="hidden" />
                  <b v-if="item.phoneCode" class="country-code">{{
                    item.phoneCode
                  }}</b>
                </div>
                <div class="validation-error" v-if="errors.length">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </template>
          </cool-select> -->
          <textInput
            name="phoneNumber"
            v-model="tel"
            class="phoneNumber"
            label="Numar de telefon*"
            validation="required|integer|length:10"
            :maxlength="10"
            :keypress="onlyNumber"
            :styles="inputStyles"
            :slideUp="tel != ''"
            :numeric="true"
            :autocomplete="'not'"
          />
        </div>
      </ValidationObserver>
      <buttonComponent
        name="sendCodeButton"
        class="sendCodeButton"
        @click.native="goto(1)"
        :text="textBtn1"
        :disabled="disabledBtn || tel.length !== 10"
        :fullWidth="fullWidthBtn"
        :styles="buttonStyles"
      />
      <div class="inputWrapper" style="margin-top: 30px">
        <ValidationObserver ref="codeInput">
          <textInput
            v-model="code"
            name="verificationCode"
            class="verificationCode"
            label="Cod de verificare"
            validation="required|integer|length:4"
            :styles="inputStyles"
            :customWrapperStyle="{ margin: 0 }"
            :maxlength="4"
            :slideUp="code != ''"
            :keypress="onlyNumber"
            :numeric="true"
            :autocomplete="'not'"
          />
        </ValidationObserver>
      </div>

      <buttonComponent
        name="sendCodeButton"
        class="sendCodeButton"
        @click.native="verify"
        :text="textBtn2"
        :disabled="active === 0 || code.length === 0"
        :fullWidth="fullWidthBtn"
        :styles="buttonStyles"
      />
    </template>
  </div>
</template>

<script>
import buttonComponent from "@/components/renderers/button-component.vue";
import textInput from "@/components/renderers/text-input.vue";
import("vue-cool-select/dist/themes/bootstrap.css");

export default {
  name: "sms-verification",
  components: { buttonComponent, textInput },
  props: {
    inputWidth: {
      required: false,
      type: String,
      default: ""
    },
    borderColorBtn: {
      required: false,
      type: String,
      default: ""
    },
    textColorBtn: {
      required: false,
      type: String,
      default: "#fff"
    },
    textBtn1: {
      required: false,
      type: String,
      default: "Button"
    },
    textBtn2: {
      required: false,
      type: String,
      default: "Button"
    },
    borderRadiusBtn: {
      required: false,
      type: String,
      default: ""
    },
    disabledBtn: {
      required: false,
      type: Boolean,
      default: false
    },
    fullWidthBtn: {
      type: Boolean
    },
    generateUrl: String,
    authUrl: String,
    onSuccess: {
      type: Object
    },
   buttonStyles:{
     type:Object,
     required:false,
     default: () => ({})
   },
   inputStyles:{
     type:Object,
     required:false,
     default: () => ({})
   }
  },
  data() {
    return {
      options: [
        { value: "+49", text: "+49" },
        { value: "+90", text: "+90" },
        { value: "+389", text: "+389" }
      ],
      countryCode: "",
      selectedCountry: "",
      active: 0,
      tel: "",
      code: "",
      items: [
        {
          "name": "Romania",
          "code": "RO",
          "phoneCode": "+40"
        }
        // {
        //   "name": "Andere",
        //   "code": "other"
        // }
      ]
    };
  },
  methods: {
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },
    async goto(page) {
      const isValid = await this.$refs.numberForm.validate();
      // const isPhoneNumber = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/.test(`${this.countryCode}${this.tel}`)
      if(!isValid) return;
      // if(!isPhoneNumber){
      //  return this.$store.commit('setModalOptions', { type: 'error', isActive: true, message: "Die Telefonnummer ist nicht gültig." })
      // }

      const formData = {
        mobile: `+${this.countryCode}${this.tel.startsWith('0') ? this.tel.substring(1) : this.tel}`
      };
      const endpoint = this.generateUrl;

      this.$store.dispatch("generateCode", { formData, endpoint }).then(r => {
        this.active = page;
        this.showModal('Mesajul cu codul de verificare a fost trimis', 'success');
      });
    },
    async verify() {
      const isValid = await this.$refs.codeInput.validate();
      if (!isValid) return;
      // console.log("VERiFY CODE");
      //do the verification... then ->
      const formData = {
        mobile: `+${this.countryCode}${this.tel.startsWith('0') ? this.tel.substring(1) : this.tel}`,
        code: this.code
      };
      const endpoint = this.authUrl;
      this.$store.dispatch("verifyCode", { formData, endpoint }).then(r => {
        if (r.response) {
          const fn = this.onSuccess.fn;
          const params = this.onSuccess.params;
          this.$store.commit('setField', { field: "formData", value: { "referenceNumber": r.referenceNumber } });
          this[fn](!r.isRegistered ? params[0] : params[1], this);
        } else {
          this.showModal('Cod de verificare invalid')
        }
      });
    },
    getFlag(flagName) {
      try {
        return require(`../../../assets/icons/flags/${flagName.toLowerCase()}.svg`);
      } catch (e) {
        return ""
      }
    },
    onCountrySelected(item) {
      if (item.code === "other") {
        this.$refs.customInput.focus()
        this.countryCode = ""
      }
      if (item.phoneCode) {
        this.countryCode = +item.phoneCode
      }
    }
  },
  mounted() {
    this.selectedCountry = this.items[0].code
    this.countryCode = +this.items[0].phoneCode

  }
};
</script>
<style>
.smsVerificationWrapper.text-center.col-lg-12.component-wrapper
  > span
  > div
  > div.m-0.p-0.countryCode
  > span
  > div
  > span {
  font-size: 10px !important;
}
</style>
<style lang="scss" scoped>
.sms-button {
  background-color: #081821;
}

.smsVerificationWrapper {
  font-family: inherit;

  .description {
    font-size: 14px;
    &.bigger {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .sendCodeButton {
    max-width: 350px !important;
    margin-top: 30px;
  }
}

.title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.inputWrapper {
  display: flex;
  justify-content: center;
  .countryCode {
    font-size: 10px;
    width: 120px !important;
  }
  .phoneNumber {
    min-width: 185px;
  }
  .verificationCode {
    width: 180px;
  }
}

.country-flag {
  width: 30px;
}

::v-deep .IZ-select {
  .IZ-select__input-wrap {
    height: auto;
    margin: 5px;
  }

  .IZ-select__input {
    border: none;
    box-shadow: none;
    width: 100px;
    padding-left: 0;
  }

  .IZ-select__menu {
    width: 200px !important;
  }

  .IZ-select__input--selection-slot {
    & > div {
      flex: 1 1 auto;
    }
  }

  input {
    display: none;

    &.custom-input {
      display: block;
    }
  }
}

.country-selected-item {
  height: 48px !important;
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0;
  border: 1px solid #808080;
  cursor: pointer;
  &.is-invalid {
    border-color: #dc3545;
    background-color: #fff0f1;
  }

  .country-flag {
    margin-left: 12px;
    margin-right: 10px;
  }

  .custom-input-wrap {
    padding-left: 0.75rem;
    display: inline-flex;
    align-items: center;

    .custom-input {
      padding-left: 4px;
      padding-right: 28px;
    }
    .custom-input-warn {
      position: absolute;
      right: 15px;
      width: 16px;
    }
  }
}

.country-item {
  display: flex;
  align-items: center;

  .country-code {
    margin-left: 10px;
  }
}
</style>
